import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Box, Button, styled } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import "./AdminCurrentRound.scss";
import { UserResult, UserResultsResponse } from "models/Models";

export const AdminPoints = () => {
  const [users, setUsers] = useState<UserResult[]>([]);
  const [year, setYear] = useState<number>();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    //TODO:DF Local loading indicator
    axios.get<UserResultsResponse>(`${process.env.REACT_APP_API_URL}/user/results/all`).then((r) => {
      setUsers(r.data.results);
      setYear(r.data.year);
      setIsLoaded(true);
    });
  }, []);
const pointsColumnWidth = 100;

  const columns: GridColDef[] = [
    { field: "teamName", headerName: "Name", width: 150 },
    {
      field: "firstRoundPoints",
      headerName: "Round 1",
      width: pointsColumnWidth,
      type: "number",
    },
    {
      field: "secondRoundPoints",
      headerName: "Round 2",
      width: pointsColumnWidth,
      type: "number",
    },
    {
      field: "thirdRoundPoints",
      headerName: "Round 3",
      width: pointsColumnWidth,
      type: "number",
    },
    {
      field: "finalRoundPoints",
      headerName: "Cup Final",
      width: pointsColumnWidth,
      type: "number",
    },
    {
      field: "pickPercent",
      headerName: "Pick %",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value }) => `${Math.round((value * 100))}%`,
    },
    {
      field: "total",
      headerName: "Total",
      width: pointsColumnWidth,
      type: "number",
    },
   
  ];

  const update = async () => {
    //TODO:DF local loading indicator
    var result = await axios.post<UserResultsResponse>(`${process.env.REACT_APP_API_URL}/admin/calculate/points`);
    setUsers(result.data.results);
    setYear(result.data.year);
  };

  return (
    <div className="admin-current-round">
      <div className="command-list">
        <Button variant="outlined" size="small" onClick={update} disabled={new Date().getFullYear() !== year}>
          Calculate
        </Button>
      </div>
      <Box>
        <DataGrid
          getRowId={(c) => c.userId}
          autoHeight
          rowHeight={30}
          hideFooter={true}
          rows={users}
          columns={columns}
          disableRowSelectionOnClick
        />
      </Box>
    </div>
  );
};
